import React, { useContext, useEffect, useState } from 'react';

import {
  Grid,
  Typography,
} from '@material-ui/core';

import {
  useHistory,
  useParams,
  withRouter,
} from 'react-router-dom';

import PropTypes from 'prop-types';

import BreadCrumb from '../../fields/breadCrumb';
import SchedulesList from '../../fields/schedulesList';
import Footer from '../../fields/footer';
import Header from '../../fields/header';
import MenuDrawer from '../../fields/menuDrawer';
import SpinnerLoading from '../../feedback/spinnerLoading';

import { getClinicianEnrolments, getPatientUserSchedules, getPatients, getAllSchedulingPatterns, getPrograms, modifyUserSchedule } from '../../../utils/comms';

import translations from '../../../languages/i18n';

import generalStyles from '../../../styles/generalStyles';
import { sectionTitle } from '../../../styles/formElementsStyles';

// NOTA: Per poder emprar el react-router-dom i enllaçar pàgines s'ha de convertir el component en una funció i exportar-lo embolicat per withRouter
// En cas de que el component sigui un fill directe de Route no fa falta fer-ho
// Explicat al punt 2.1. Using withRouter de https://dev.to/projectescape/programmatic-navigation-in-react-3p1l

import { SessionContext } from '../../../utils/context';

function ListPatientSchedules({ lang, handleChangeLang }) {
  const { idPatient } = useParams();
  const sessionContext = useContext(SessionContext);

  const [schedulesList, setSchedulesList] = useState([]);
  const [patient, setPatient] = useState({});
  const [showDrawer, setShowDrawer] = useState(false);
  const [showLoading, setShowLoading] = useState(false);

  const history = useHistory();
  const classes = generalStyles();
  const sectionTitleStyle = sectionTitle();

  let clinicianPatients = true;

  const getInfoFromServer = async () => {
    setShowLoading(true);
    const patientsFromServer = await getPatients(sessionContext.userToken);
    if (patientsFromServer.status === 200) {
      const patientInfo = patientsFromServer.data.patients.filter((item) => item._id === idPatient);
      setPatient(patientInfo[0]);
    } else if (patientsFromServer === 400) { // Error amb les dades
      console.log('Error 400 obtenint els pacients');
    } else { // Login KO. Altres errors
      console.log(patientsFromServer);
    }

    // Obtenim els enrolments que tenen al clinic al seu equip i indicam a quins es supervisor
    let clinicianEnrolments = [];
    const clinicianEnrolmentsFromServer = await getClinicianEnrolments(sessionContext.userId, sessionContext.userToken);
    if (clinicianEnrolmentsFromServer.status === 200) {
      clinicianEnrolments = clinicianEnrolmentsFromServer.data.enrolments.map((enrolment) => {
        const supervised = enrolment.supervisedBy.some((member) => member.admin && member.clinician === sessionContext.userId);
        return ({ enrolmentId: enrolment._id, supervised });
      });
    } else if (clinicianEnrolmentsFromServer === 400) { // Error amb les dades
      console.log('Error 400 obtenint els enrolments del clinic');
    } else { // Login KO. Altres errors
      console.log(clinicianEnrolmentsFromServer);
    }

    const schedulingPatterns = await getAllSchedulingPatterns(sessionContext.userToken);
    if (schedulingPatterns.status === 200) {
      // console.log('schedulingPatterns: ');
      // console.log(schedulingPatterns.data);
      const programs = await getPrograms(sessionContext.userToken);
      if (programs.status === 200) {
        // console.log('programs: ');
        // console.log(programs.data);
        const schedulesFromServer = await getPatientUserSchedules(idPatient, sessionContext.userToken);
        if (schedulesFromServer.status === 200) { // Tenim llistat
          // console.log('getPatientUserSchedules de ' + idPatient + ' :');
          // console.log(schedulesFromServer.data);
          const schedules = [];
          schedulesFromServer.data.userSchedules.map((item) => {
            // Filtram per mostrar només els formularis associats a algun dels programes que administra el clínic
            if (programs.data.programs.some((program) => item.enrolment.program === program._id)) {
              let myScheduling = null;
              if (item.schedulingPattern) {
                myScheduling = schedulingPatterns.data.schedulingPatterns.filter((element) => element._id === item.schedulingPattern);
              } else {
                myScheduling = schedulingPatterns.data.schedulingPatterns.filter((element) => element._id === item.schedulingPatterns[0].schedulingPattern);
              }
              // console.log('myScheduling:');
              // console.log(myScheduling);
              const myProgram = programs.data.programs.filter((program) => program._id === myScheduling[0].program);
              const editableByClinician = clinicianEnrolments.some((enrolment) => enrolment.supervised && enrolment.enrolmentId === item.enrolment._id);
              schedules.push({
                ...item,
                scheduleName: item.schedulingPattern ? myScheduling[0].desc : item.name,
                programName: myProgram[0] && myProgram[0].sharedId,
                editableByClinician,
              });
            }
          });
          if (schedules.length === 0) clinicianPatients = false; // Els formularis no són de pacients associats o de programes administrats pel clinic
          // Llevam els userSchedules que estiguin completats
          const notCompletedUserSchedules = schedules.filter((userSchedule) => userSchedule.completed !== true);
          setSchedulesList(notCompletedUserSchedules);
        } else if (schedulesFromServer === 400) { // Error amb les dades
          console.log('Error 400 obtenint els User Schedules ');
        } else { // Login KO. Altres errors
          console.log(schedulesFromServer);
        }
      } else if (programs === 400) { // Error amb les dades
        console.log('Error 400 obtenint els programes');
      } else { // Login KO. Altres errors
        console.log(programs);
      }
    } else if (schedulingPatterns === 400) { // Error amb les dades
      console.log('Error 400 obtenint els Scheduling Patterns');
    } else { // Login KO. Altres errors
      console.log(schedulingPatterns);
    }
    setShowLoading(false);
  };

  useEffect(() => {
    getInfoFromServer();
  }, []); // [] Indica que l'useEffect només s'executa una vegada, no a cada render

  const gotoScreen = (screen) => {
    history.push(`/${sessionContext.role.toLowerCase()}/${screen}`);
  };

  const showMenuDrawer = (show) => {
    setShowDrawer(show);
  };

  const changeUserSchedule = (out, idSchedule, token) => {
    (async () => {
      const putResponse = await modifyUserSchedule(out, idSchedule, token);
      if (putResponse.status === 200) {
        getInfoFromServer();
      } else if (putResponse === 400) { // Error amb les dades
        console.log('Error 400 modificant UserSchedule');
      } else { // Login KO. Altres errors
        console.log(putResponse);
      }
    })();
  };

  return (
    <div className={classes.content}>
      <SpinnerLoading show={showLoading} />
      {/* ATENCIÓ: el role ve del servidor amb la primera lletra en majuscula, jo ho necessit tot en minuscula */}
      <Header type={sessionContext.role.toLowerCase()} handleShowDrawer={(show) => showMenuDrawer(show)} lang={lang} handleChangeLang={handleChangeLang} />
      <MenuDrawer type={sessionContext.role.toLowerCase()} showDrawer={showDrawer} handleShowDrawer={(show) => showMenuDrawer(show)} handleGotoScreen={(screen) => gotoScreen(screen)} />
      <div className={classes.body}>
        <Grid container direction='column' spacing={2}>
          {/* ----------------------- Fila 0 ----------------------- */}
          <Grid item xs={12}>
            <BreadCrumb role={sessionContext.role.toLowerCase()} home='listPatients' lang={lang} />
          </Grid>
          {/* ----------------------- Fila 1 ----------------------- */}
          <Grid item className={sectionTitleStyle.root}>
            <Grid container justify='space-between' spacing={2}>
              <Grid item>
                <Typography variant='h4' component='div' className={sectionTitleStyle.title}>
                  {`${translations['_patientForms']} ${patient.username}`}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
          {/* ----------------------- Fila 2 ----------------------- */}
          <Grid item>
            <Grid container justify='space-between' spacing={2}>
              <Grid item xs={12}>
                {(!clinicianPatients && schedulesList.length === 0 && sessionContext.role !== 'Admin') ? (
                  <Typography variant='h6' component='div' className={sectionTitleStyle.title}>{translations._emptyPatientForms}</Typography>
                ) : (
                  <SchedulesList
                    editScheduleData={changeUserSchedule}
                    schedulesData={schedulesList}
                    userInfo={patient}
                    userType='patient'
                  />
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </div>
      <Footer />
    </div>
  );
}

export default withRouter(ListPatientSchedules);

// Indica i controla els props que se han de passar al component
ListPatientSchedules.propTypes = {
  lang: PropTypes.string.isRequired,
  handleChangeLang: PropTypes.func.isRequired,
};
